import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import CountUp from "react-countup";
import Confetti from "react-confetti";
import useWindowSize from "react-use/lib/useWindowSize";
import promo1 from "../imgs/img1.jpg";
import promo2 from "../imgs/img2.webp";
import promo3 from "../imgs/img22.jpg";
import video1 from "../imgs/video1.mp4";
import video2 from "../imgs/video2.mp4";
import banner from "../imgs/banner2.png"
import "../css/movieproduction.css";

export const MovieProduction = () => {

      const { width, height } = useWindowSize();
  const [showConfetti, setShowConfetti] = useState(false);

  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });

  useEffect(() => {
    if (inView) setShowConfetti(true);
  }, [inView]);

  return (
    <div className="movie-side"><img alt="" src={banner} /><div className="movie-promo-container" >
         
   {showConfetti && (
  <Confetti
    width={width}
    height={height}
    numberOfPieces={250}
    recycle={false}
    gravity={0.2}
  />
)}
      
<div className="promo-wrapper-movie">
  <motion.h1
    initial={{ opacity: 0, y: -30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
    className="promo-title"
  >
    <span className="highlight">Oho Endhan Baby</span>
  </motion.h1>

  <motion.div
    ref={ref}
    initial={{ opacity: 0 }}
    animate={inView ? { opacity: 1 } : {}}
    transition={{ duration: 1 }}
    className="promo-description"
  >
<p>
  At <span className="brand-text">Lotus Meta Production</span>, we were thrilled to be part of the promotional journey for 
  <span className="highlight"> Oho Endhan Baby</span>, featuring
  <span className="actor rudra"> Rudra Vishal</span> (Vishnu Vishal’s younger brother), 
  <span className="actor mithila"> Mithila Palkar</span>  and a stellar cast including
  <span className="actor mysskin"> Mysskin</span>, and 
  <span className="actor karunakaran"> Karunakaran</span>.
</p>
   <ul className="promo-list">
  <li>
    <span className="bullet-point" /> Reels around the trailer launch
  </li>
  <li>
    <span className="bullet-point" /> Behind-the-scenes dinner meet
  </li>
  <li>
    <span className="bullet-point" /> Countdown reels on Instagram
  </li>
</ul>

    <p>
      Our digital efforts created a buzz on social media, with total views crossing
      <span className="count"> <CountUp end={20000} duration={3} />+</span>,
      building huge anticipation for the film's release on 
      <strong className="release-date"> July 11, 2025</strong>.
    </p>
  </motion.div>
</div>


      {/* Media section */}
      <div className="media-grid" >
        {[promo1, promo2, promo3].map((img, idx) => (
          <motion.img
            key={idx}
            src={img}
            alt={`Promo ${idx + 1}`}
            whileHover={{ scale: 1.05 }}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: idx * 0.3 }}
          
          />
        ))}

        {[video1, video2].map((vid, idx) => (
          <motion.video
            key={idx}
            src={vid}
            controls
            loop
            muted
            autoPlay
            whileHover={{ scale: 1.03 }}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: (idx + 3) * 0.3 }}
        
          />
        ))}
      </div>
    </div></div>
  )
}
